// @vendor
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @components
import { OKCollapsingToggler } from 'commonsComponents/OKCollapsingToggler';
import TextToggle from 'components/commons/textToggle/textToggle';
import CountryListItem from './CountryListItem';
// @utilities
import { sortCountryNames } from './sortNames';
const { FormattedText } = require('core/i18n').i18n;
// @tagging
import { EVENT_CARD_CONTROL } from 'utilities/tagging';

const isZoneActive = data => data.some(country => country.enabled);

const activeClass = data => {
    if (data.every(country => country.enabled)) return 'enabled';
    if (data.some(country => country.enabled)) return 'partial';
    return 'disabled';
};


const ZoneListItem = ({ data, code, name, open, onClick, onCountryClick, onSelect, disabled, originCountry }) => (
    <div className={classNames('container--actions', activeClass(data))}>

        <div className="dropdown-countries-container row">

            <div
                className="dropdown-countries-container__label col-xs-11"
                onClick={() => onSelect && !disabled && onSelect(code)}
              >
                <OKCollapsingToggler
                    handlerToggle={() => {}}
                    isExpanded={open}
                />
                <span className="countries-info">
                    <span className="country-name" >
                        {name}&nbsp;({data.length})
                    </span>
                    <span className="enable-info">
                        {
                          data.every(country => country.enabled) &&
                          <FormattedText value="cardsConfig-countriesEnabledAll" />
                        }
                        {
                          !data.every(country => country.enabled) &&
                          data.filter(country => country.enabled).length === 1 &&
                          <FormattedText value="cardsConfig-countriesEnabledOne"
                              className="num-countries"
                          />
                        }
                        {
                          !data.every(country => country.enabled) &&
                          data.filter(country => country.enabled).length === 0 &&
                          <FormattedText value="cardsConfig-noCountriesEnabled" />
                        }
                        {
                          !data.every(country => country.enabled) &&
                          data.filter(country => country.enabled).length > 1 &&
                          <FormattedText
                              className="num-countries"
                              value="cardsConfig-countriesEnabled"
                              injectedStrings={[data.filter(country => country.enabled).length]}
                          />
                        }
                    </span>
                </span>
            </div>

            <div
                className="dropdown-countries-container__toggle col-xs-1"
                onClick={() => onClick && !disabled && onClick(code, isZoneActive(data))}
              >
                <TextToggle
                    checked={isZoneActive(data)}
                    onClick={() => onClick && !disabled && onClick(code, isZoneActive(data))}
                    eventCategory={EVENT_CARD_CONTROL}
                    eventTag={code}
                    textCheck='ON'
                    textUncheck='OFF'
                    isCardControlSection
                />
            </div>

        </div>

        {
            open &&
            <div className="contries-container">
                <ul>
                    {
                        data
                        .sort((countryA, countryB) => sortCountryNames(countryA, countryB, originCountry))
                        .map(country => (
                            <li key={country.name}>
                                <div className="dropdown-item-info">
                                    <CountryListItem
                                        active={country.enabled}
                                        code={country.name}
                                        name={country.nameLiteral}
                                        onClick={onCountryClick}
                                        disabled={disabled}
                                    />
                                </div>
                            </li>
                        ))
                    }
                </ul>
            </div>
        }

    </div>
);


ZoneListItem.propTypes = {
    data: PropTypes.array.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onCountryClick: PropTypes.func,
    onClick: PropTypes.func,
    onSelect: PropTypes.func,
    originCountry: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};


export default ZoneListItem;
